import { useContext } from 'react'

import {
  Box, ModalContext, SidebarModal, Text,
} from '@domain-group/suit-theme'

import useTaskListTemplateItems from '@hooks/useTaskListTemplateItems'

import TaskListTemplateItem from './components/TaskListTemplateItem'

const MODAL_KEY = 'ViewChecklistTemplateModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  requestOptions?: object,
  showModal: boolean,
}

const ViewChecklistTemplateModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = modalData?.[MODAL_KEY] ?? {}
  const { taskListTemplate = {} } = modalPayload

  const taskListTemplateItemsPayload = useTaskListTemplateItems({
    filters: {
      task_list_template_id: taskListTemplate?.id,
    },
    performHttpRequests: !!taskListTemplate?.id,
  })

  const { filteredTaskListTemplateItems } = taskListTemplateItemsPayload

  return (
    <SidebarModal callbacks={callbacks} modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="View" titleSecondLine="Checklist Template" />

      <SidebarModal.SubHeader>
        <Box boxProps={{ lineHeight: 1.3 }} flexDirection="column">
          <Text color="bodyFontColor" fontSize="small">
            {taskListTemplate?.title}
          </Text>

          <Text
            color="bodyFontLightColor"
            fontSize="xsmall"
            marginTop="medium"
          >
            {`Checklist Template #${taskListTemplate?.id}`}
          </Text>
        </Box>
      </SidebarModal.SubHeader>

      <SidebarModal.Content boxProps={{ paddingY: 0 }} hasFooter={false}>
        <Box flexDirection="column">
          {filteredTaskListTemplateItems.map(taskListTemplateItem => (
            <TaskListTemplateItem key={taskListTemplateItem.id} taskListTemplateItem={taskListTemplateItem} />
          ))}
        </Box>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ViewChecklistTemplateModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
